import * as React from 'react';
import * as d3Axis from 'd3-axis';
import {select} from 'd3-selection';
import {Margins, Scales, Size} from '../../types';
import {theme} from '../style';

interface CleanArrowLeftAxisProps {
  scales: Scales;
  margins: Margins;
  svgDimensions: Size;
  label: string;
}

/**
 * A clean, singular left axis with label.
 * Note that this doesn't actually use d3 axis
 *
 * label - string label for the axis
 */
export class CleanArrowLeftAxis extends React.Component<CleanArrowLeftAxisProps> {
  private readonly axisElement: React.RefObject<SVGSVGElement>;

  constructor(props: CleanArrowLeftAxisProps) {
    super(props);
    this.axisElement = React.createRef();
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    const {scales} = this.props;

    const axis = d3Axis.axisLeft(scales.yScale).ticks(0).tickSize(0);

    select(this.axisElement.current!).call(axis);
  }

  render() {
    const {margins, svgDimensions, label} = this.props;

    return (
      <g>
        <g
          className={`Axis Axis-left`}
          ref={this.axisElement}
          markerEnd={'url(#arrowhead)'}
          transform={`translate(${margins.left}, ${margins.top})`}
          style={{color: theme.colors.chartTextPrimary}}
        />
        <text
          y={0}
          x={-(svgDimensions.height / 2)}
          transform="rotate(-90)"
          dy={'1.8em'}
          textAnchor="middle"
          fontFamily={theme.fonts.primaryFontFamily}
          fontSize="10px"
          fill={theme.colors.chartTextTertiary}
          fontWeight="bold">
          {label}
        </text>
      </g>
    );
  }
}
